<template>
  <div class="lv-loading-card">
    <WsCard001
      v-for="(card, cardIndex) in quantity"
      :key="cardIndex"
      class="lv-loading-card__items"
    >
      <SkeletonAnimate class="skelete-1 skekete" />
      <SkeletonAnimate class="skelete-2 skekete" />
      <SkeletonAnimate class="skelete-3 skekete" />
      <SkeletonAnimate class="skelete-4 skekete" />
      <SkeletonAnimate class="skelete-5 skekete" />
    </WsCard001>
  </div>
</template>

<script>
export default {
  props: {
    quantity: {
      type: Number,
      default: 8,
    }
  }
}
</script>